'use strict'

export let english={
  reason: {
    title:"Who need what and why?",
    fields: {
      name: {
        title: "Project Name",
        description: "A descriptive name of the project",
        help: "Tell me about the project you have in mind."
      },
      objectives: {
        title: "Business Objective",
        help: `What opportunity are we going after?
          What’s the business need that this project is intended to address?
          What is it that we are fixing, trying to improve, or solve?
          How will the project enable your organization to serve its customers better?`,
        description: "The reason to run the project"
      },
      deliverables: {
        title: "Project Deliverable Quality and Scope",
        help: `These questions dvelve into the product or service that is to be produced: “If we had it in place right now [the process, system, the product, the new service] …”

          What would you see as its main functions or features?
          Is this intended to be a stop-gap measure: We’ll do it once, and if we replace it, will we start all over from scratch? Or are we trying to do something that we will attempt to fix and upgrade over time?
          What would be the absolute bare minimum functions?
          What would it physically look like?`,
        description: "The qualities of deliverables and project scope"
      },
      outcomes: {
        title: "Business Outcome",
        help: `These questions are aimed at identifying the value-added dollar-and-cents benefits that are being sought as a result of having produced the project deliverable. “Assuming we had completed the project and it was now up and running…”

          What s the most important payoff you are looking to achieve? Increased revenue? Better customer service? Greater marked share? Decreased cost of doing business? Short-term profits?
          How would you quantify the dolar payoff you are targeting? ROI? Reduced cost? Over what period of time?
          What will you want to see to know that the business benefits have been achieved?
          Under what conditions would we shut down the project?`,
        description:"The expected result of the project"
      }
    }
  },
  surroundings: {
    title:"Surroundings",
    fields: {
      context: {
        title:"Context",
        help: `These questions elict information about the business climate surrounding the project:

          How does this project fit in with the origanization’s overall business strategy?
          Who’s driving this project from above?
          Who will you be going to for approvals and funding?
          What’s driving us to this now? What is we did nothing? Waited until next year?
          How does this fit into the overall priority of projects?
          If we have to let another project slip, what might that be?`,
        description:"In which context does the project exist"
      },
      stakeholders: {
        title: "Stakeholders",
        help:`These questions relate to the politics of the project. Here you want to find out whom this project is intended to affect, for better or for worse. Thiose affected can be wither internal or external to your organization.

          For whose benefit is the project being undertaken?
          What customer group or department is the project intended to affect?
          Who is likely to feel threathened by this project or have strong opinions?
          Who do we need to talk to that has to be happy with the resoults?
          Who are the strong supporters of this project?`,
        description: "Who are affected by the project"
      }
    }
  },
  dependencies: {
    title: "Dependencies",
    fields: {
      timing: {
        title:"Timing",
        help:`What’s the time frame or deadline you have in mind?
          What’s driving the deadline?
          What latitude is there?`,
        description:"In which time period will the project be performed"
      },
      resources: {
        title:"Resources and Budget",
        help:`What would you expect to spend on this project?,
          Whose budget is this coming out of?
          Who will I talk to when I need staff for the project?`,
        description: "What is required to run the project"
      },
      tradeOffs: {
        title: "Trade-Offs",
        help:`When trade-offs have to be made, which one of the drivers for this project must be achived (that is, it cannot be sacrificed)?

          ROI, time line, budget, functions and features, quality, customer / stakeholder satisfaction, team satisfaction?
          What is the second most important driver?`,
        description:"What are the priorities"
      }
    }
  },
  relationship: {
    title: "Relationship",
    fields: {
      relations: {
        title:"Working Relationship",
        help:`How do you see your role with respect to decision making? Funding? Staffing? Who else wil you look to for this?
          How do you see my role on the project?
          What progress reporting information will be important to you?`,
        description: "What are the expectations to you as responsible for the project"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./views/extremeProject/labels/english.js